import { Badge } from '../../components/ui/badge';
import { ShieldCheck, ShieldAlert, ShieldOff } from 'lucide-react';
import { RestrictionLevel } from '../../types';

interface RestrictionBadgeProps {
  level: RestrictionLevel;
  showLabel?: boolean;
}

const restrictionConfig: Record<RestrictionLevel, { label: string; icon: typeof ShieldCheck; variant: 'restriction0' | 'restriction1' | 'restriction2' }> = {
  0: { label: 'Sem Restrição', icon: ShieldCheck, variant: 'restriction0' },
  1: { label: 'Restrição Parcial', icon: ShieldAlert, variant: 'restriction1' },
  2: { label: 'Restrito', icon: ShieldOff, variant: 'restriction2' },
};

export function RestrictionBadge({ level, showLabel = true }: RestrictionBadgeProps) {
  const config = restrictionConfig[level];
  const Icon = config.icon;

  return (
    <Badge variant={config.variant} className="gap-1">
      <Icon className="h-3 w-3" />
      {showLabel && <span>{config.label}</span>}
    </Badge>
  );
}

export function getRestrictionLabel(level: RestrictionLevel): string {
  return restrictionConfig[level].label;
}
